// getIsCategoryEmpty.js
'use strict';
import { parseCategoryString } from '../component/FeedComponent.jsx';

import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import createCachedSelector from '../resource/createCachedSelector.js';
import { getFeedNameType } from '../resource/feedUtils.js';

/**
 * Select is first page fetched and empty.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} categories - categories.
 * @return {boolean} Return true if categories are empty and first page fetched.
 */
const getIsCategoryEmpty = createCachedSelector(
  (state, categories) =>
    categories.every(originCategory => {
      const { category } = parseCategoryString({ category: originCategory });
      return getNetworkingData(
        state,
        ['home', getFeedNameType({ feedName: category }), category, 1],
        'isFetched'
      );
    }),
  (state, categories) =>
    categories.every(originCategory => {
      const { category } = parseCategoryString({ category: originCategory });
      const ids =
        getListData(
          state,
          ['home', getFeedNameType({ feedName: category }), category],
          'itemIds'
        ) || [];
      return ids.length === 0;
    }),
  (isFetched, isEmpty) => {
    return isFetched && isEmpty;
  }
)((state, categories) => `${categories}`);

export default getIsCategoryEmpty;
